import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MinimalCatalogRecord as MinimalCatalogRecordForCoverImage} from '@aviary/components/cover-image/cover-image.component';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {CombinedCoverTitleDetailComponent} from '@lib/components/combined-cover-title-detail/combined-cover-title-detail.component';
import {ItemRequest} from '@store/item-requests/item-requests.types';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';

export type MinimalCatalogRecord = MinimalCatalogRecordForCoverImage & {
  id: number;
  title: string;
};

@Component({
  selector: 'px-item-request-title-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    @if ({
      isMdOrAbove: viewportSelectors.isMdAndUp | select:false
    }; as vm) {
      @if (selectors.hasLinkedCatalogRecordFor(itemRequest) | select) {
        <px-combined-cover-title-detail [catalogRecord]="catalogRecord" [showCover]="vm.isMdOrAbove" [titleMaxLines]="2"/>
      } @else {
        <p mxTruncate [mxTruncateMaxLines]="2" class="text-body-large">{{ selectors.titleFor(itemRequest) | select }}</p>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TruncateDirective, CombinedCoverTitleDetailComponent, SelectPipe]
})
export class ItemRequestTitleComponent {
  @Input({required: true}) public itemRequest: ItemRequest;
  @Input({required: true}) public catalogRecord: MinimalCatalogRecord;
  public readonly selectors = ItemRequestsSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;
}
